import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { ShareDocumentsMessageDto } from "@teamprevent/common/shareDocuments/models";

import { loadOhCaseDetailSuccess } from "../crud/ohCase/actions";

import { SEND_DOCUMENTS_TO_ASSOCIATE } from "./actionTypes";
import { shareDocumentsApi } from "./shareDocumentsApi";

export const sendDocumentsToAssociate = (ohCaseId: string, model: ShareDocumentsMessageDto) => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            SEND_DOCUMENTS_TO_ASSOCIATE,
            shareDocumentsApi.sendDocumentsToAssociate(ohCaseId, model)
        );
        dispatch(loadOhCaseDetailSuccess(response));
    };
};
